import { SimulateTradeTrigger } from './parts/SimulateTradeTrigger';
import { SimulateTradeDialog } from './parts/SimulateTradeDialog';
import { SimulateTradeLink } from './parts/SimulateTradeLink';

export const SimulateTrade = {
  Trigger: SimulateTradeTrigger,
  Link: SimulateTradeLink,
  Dialog: SimulateTradeDialog
};
